import { Controller } from '@hotwired/stimulus';

/**
 * Quick-select buttons for pilot duration date input.
 * Sets the date input value to today + N days.
 * Shared between organization detail page and creation form.
 *
 * Usage:
 *   <form data-controller="pilot-duration">
 *     <input type="date" data-pilot-duration-target="dateInput" />
 *     <button data-action="click->pilot-duration#setDays" data-pilot-duration-days-param="7">+7j</button>
 *     <button data-action="click->pilot-duration#setDays" data-pilot-duration-days-param="14">+14j</button>
 *     <button data-action="click->pilot-duration#setDays" data-pilot-duration-days-param="30">+30j</button>
 *     <button data-action="click->pilot-duration#clearDate">Retirer</button>
 *   </form>
 */
export default class extends Controller {
  static targets = ['dateInput'];

  setDays({ params: { days } }) {
    const date = new Date();
    date.setDate(date.getDate() + parseInt(days, 10));
    this.dateInputTarget.value = date.toISOString().split('T')[0];
    this.dateInputTarget.dispatchEvent(new Event('change', { bubbles: true }));
  }

  clearDate() {
    this.dateInputTarget.value = '';
    this.dateInputTarget.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
